import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["frame"]

  static values = { url: String }

  update() {
    this.frameTarget.src = this.url
  }

  get url() {
    const url = new URL(this.urlValue, location)
    for (const [key, value] of this.formData) {
      if (!key.match(/token|title|description/)) {
        url.searchParams.append(key, value)
      }
    }
    return url
  }

  get formData() {
    return new FormData(this.element)
  }
}
